import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { NavCurrentUser } from '@utils/backend-api/currentUser';

import TopNav from './TopNav';

const queryClient = new QueryClient();
export default function Nav({
  colorScheme,
  currentUser,
  isFullNav,
  isWebview,
  newForumPostsCount,
  overrideOfferCode,
  shouldOpenReferralModal,
}: {
  colorScheme?: string;
  currentUser: NavCurrentUser;
  isFullNav: boolean;
  isWebview: boolean;
  newForumPostsCount: number;
  overrideOfferCode?: string;
  shouldOpenReferralModal: boolean;
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <TopNav
        colorScheme={colorScheme}
        currentUser={currentUser}
        isFullNav={isFullNav}
        isWebview={isWebview}
        newForumPostsCount={newForumPostsCount}
        overrideOfferCode={overrideOfferCode}
        shouldOpenReferralModal={shouldOpenReferralModal}
      />
    </QueryClientProvider>
  );
}
